import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import api from '@/api';
export default {
  name: 'agencyMemberExaminationList',
  data: function data() {
    return {
      props: {
        multiple: true
      },
      isSelect: this.checkauthority('agency_Member_Examination_select'),
      isCreate: this.checkauthority('agency_create'),
      isUpdate: this.checkauthority('agency_update'),
      isDelete: this.checkauthority('agency_dj'),
      selectForm: {
        startCreateTime: null,
        endCreateTime: null,
        stats: null,
        agencyName: null
      },
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0
    };
  },
  methods: {
    exportExcel: function exportExcel() {
      var par = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        stats: this.selectForm.stats,
        endCreateTime: this.selectForm.endCreateTime,
        startCreateTime: this.selectForm.startCreateTime,
        agencyName: this.selectForm.agencyName
      };
      var apiUrl = 'admin/v1/AgencyMemberExamination/export';
      this.downloadUtil.excelExport(apiUrl, par, '考核年度记录表.xls');
    },
    checkStats: function checkStats(op) {},
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.startCreateTime = null;
      this.selectForm.endCreateTime = null;
      this.selectForm.stats = null;
      this.selectForm.agencyName = null;
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                pageNo: _this.pageNo,
                pageSize: _this.pageSize,
                stats: _this.selectForm.stats,
                endCreateTime: _this.selectForm.endCreateTime,
                startCreateTime: _this.selectForm.startCreateTime,
                agencyName: _this.selectForm.agencyName
              };
              _context.n = 1;
              return api.GET_AGENCYMEMBEREXAMINATION_PAGE_LIST(par);
            case 1:
              res = _context.v;
              _this.tableData = res.body.datas;
              _this.pageTotal = res.body.sumDataCount;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initTableData();
  }
};